$('document').ready(function () {

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/";
	}

	if (typeof PARTNERGET !== 'undefined' && PARTNERGET) {
		setCookie('partner', PARTNERGET, 90);
	}
	if (typeof GCLIDGET !== 'undefined' && GCLIDGET) {
		setCookie('gclid',GCLIDGET,7);
	}

	$("a.link_win").attr("href", LINKS['link_win']);
	$("a.link_win64").attr("href", LINKS['link_win64']);
	$("a.link_mac").attr("href", LINKS['link_mac']);
	$("a.link_linux").attr("href", LINKS['link_linux']);
	$("a.link_ipad").attr("href", LINKS['link_ipad']);
	$("a.link_iphone").attr("href", LINKS['link_iphone']);
	$("a.link_android").attr("href", LINKS['link_android']);

	$("a.link_changer").attr("href", LINKS['link_changer']);
	$("a.link_changer_jpksf").attr("href", LINKS['link_changer_jpksf']);
	$("a.link_faktury").attr("href", LINKS['link_faktury']);


	$("a.link_win").attr("href", LINKS['link_win']);


	if (typeof SYSTEM_DETECT !== 'undefined') {
		console.log('SYSTEM DETECT: ' + SYSTEM_DETECT);
		console.log('DEVICE DETECT: ' + DEVICE_DETECT);
		if ((DEVICE_DETECT=='phone' || DEVICE_DETECT=='tablet')) {

			var b_obj = $(".intro-buttons .button-download.link_changer");
			var o_obj = $(".intro-buttons-txt");

			o_obj.hide();

			b_obj.removeClass('button-download');
			b_obj.removeClass('link_changer');
			b_obj.addClass('button-online');
			b_obj.addClass('link_online');
			b_obj.html("<small>program fillup</small>URUCHOM");
		}
	}

	const partner = PARTNER;
	const formId  = FORM_ID;
	const catId   = CAT_ID;

	if (partner) {
		$('.link_partner').each(function() {
			const link_partner_href = $(this).attr("href");

			if (link_partner_href) {
				let param_pos_char = '?';
				const param_pos = link_partner_href.indexOf("?");

				if (param_pos>0) param_pos_char = '&';
				$(this).attr("href", `${link_partner_href}${param_pos_char}partner=${partner}`);
			}
		});
	}

	// $('.show_online, .show_online_short, .button-online, .empty-online, .menu_online, .system_online_active, .link-online-click, .link_online').attr("target",'_blank').attr("href", LINKS['link_online']);
	$('.link_online').attr("target",'_blank').attr("href", LINKS['link_online']);

	let jsaddparam = '';
	$('.link_online').each(function() {
		const currentformId = $(this).attr('data-formId');
		const currentPartner = $(this).attr('data-formPartner');

		if (typeof currentformId !== 'undefined') {
			jsaddparam = `&formId=${currentformId}`;
			$(this).prop('href', $(this).prop('href') + jsaddparam);
		}

		if (typeof currentPartner !== 'undefined') {
			jsaddparam = `&parner=${currentPartner}`;
			$(this).prop('href', $(this).prop('href') + jsaddparam);
		}
	});


	$(".header .link_download_event").attr("onclick", LINK_DOWNLOAD_EVENT.replace('PLACE','HEADER'));
	$(".header .link_online_event").attr("onclick", LINK_ONLINE_EVENT.replace('PLACE','HEADER'));
	$(".page__main .link_download_event").attr("onclick", LINK_DOWNLOAD_EVENT.replace('PLACE','MAIN'));
	$(".page__main .link_online_event").attr("onclick", LINK_ONLINE_EVENT.replace('PLACE','MAIN'));

	$(".link_faktury").attr("onclick", LINK_ONLINE_EVENT.replace('PLACE','MAIN'));


	/**
	 * obsługa okna modalnego przy klikaniu w pobierz
	 */
	$('body').on('click', 'a.down-modal, .navbar .featured', function() {
		$('#fl_download').modal('show');
	});


	/**
	 * dotyczy obsługi cennika
	 */
	if (typeof PRICELIST_RABAT_DATA !== 'undefined' && PRICELIST_RABAT_DATA) {
		setCookie('rabatData',PRICELIST_RABAT_DATA,7);
	}
});
